module.exports = __webpack_public_path__ + "img/layout1.db45bb9c.png";